var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutrasCulturasRegadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(12695 590)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12695 -590)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12693.813 588.527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.352,31.759V29.231a2.174,2.174,0,0,1-1.209-.22,4.765,4.765,0,0,1-4.286-4.725V22.858a.874.874,0,0,1,.989-.989,31.323,31.323,0,0,1,3.187.33h0a4.855,4.855,0,0,1,1.648-5.385.836.836,0,0,1,1.1,0,5.1,5.1,0,0,1,1.978,4.176,17.566,17.566,0,0,1,2.308-.549h2.088a.694.694,0,0,1,.769.769,9.977,9.977,0,0,1-.44,3.626,5.685,5.685,0,0,1-4.725,3.956,9.618,9.618,0,0,0-1.758.22v2.528H24.4V29.012a2.788,2.788,0,0,1-1.319-.22,4.82,4.82,0,0,1-4.286-4.506V22.638c0-.659.33-.879.989-.879h1.648a6.339,6.339,0,0,1,1.538.33h0c-.769-1.758-.11-3.3,1.1-4.725.989-1.209,1.429-1.209,2.418,0A4.708,4.708,0,0,1,27.8,20.88a32.21,32.21,0,0,1,3.187-.549H32.2a.751.751,0,0,1,.769.769A9.111,9.111,0,0,1,32.2,25.6a5.792,5.792,0,0,1-4.4,3.187,9.618,9.618,0,0,0-1.758.22v2.528h6.044c.659,0,.989.33.989.769a.727.727,0,0,1-.659.769h-30a.769.769,0,0,1,0-1.538H8.462ZM10,27.473c3.407,0,5.385-1.648,5.275-5.385C11.758,21.978,9.78,23.957,10,27.473ZM31.429,22.2c-3.077-.44-6.044,2.528-5.275,5.385,3.407,0,5.275-1.648,5.275-5.385ZM8.242,27.473a3.588,3.588,0,0,0-3.956-3.956C4.286,25.935,5.495,27.583,8.242,27.473Zm12.2-3.956c-.33,2.308,1.978,4.506,3.956,3.956A3.693,3.693,0,0,0,20.44,23.517Zm4.835-4.725a2.654,2.654,0,0,0,0,4.066A2.733,2.733,0,0,0,25.275,18.792ZM9.121,22.858a2.732,2.732,0,0,0,0-4.066A2.821,2.821,0,0,0,9.121,22.858Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.154,3.517a3.9,3.9,0,0,0,.44.989.824.824,0,0,1,0,.989.834.834,0,0,1-.989.33h-.549a.911.911,0,0,1-.879-.33.824.824,0,0,1,0-.989.875.875,0,0,0,.22-.989H9.89c0,.44,0,.769.22.989a.616.616,0,0,1,0,.989.834.834,0,0,1-.989.33h-.44c-.44,0-.769,0-.989-.33a1.051,1.051,0,0,1,0-.989,2.071,2.071,0,0,0,.44-.989H2.088c-.44,0-.769-.11-.879-.659a.856.856,0,0,1,.659-.989h30a.776.776,0,1,1,0,1.538H26.045a.34.34,0,0,0-.22.11Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.078,11.649c-.549,1.1-2.418,0-2.088-1.1.549-1.319,2.2,0,2.2.879h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,8.022c0,1.429-1.648,1.429-1.648,0,0-1.648,1.648-1.538,1.648,0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.264,7.912c0,1.538-1.758,1.319-1.648-.22,0-1.538,1.648-1.429,1.648,0h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.626,10.66c0,.879-1.319,2.088-1.978.989-.44-1.1,1.319-2.308,1.978-1.209h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10.989c0,1.209-1.538,1.429-1.648,0C8.132,9.231,10,9.121,10,10.769h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.616,10.66c0-1.429,1.648-1.429,1.648,0,0,1.648-1.648,1.648-1.648,0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.561,7.912A1.751,1.751,0,0,1,30.88,8.9a.844.844,0,0,1-.769,1.1c-.989,0-1.868-1.538-.769-2.088h.22Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.319,5.824c.989.11,1.978,1.868.549,2.088-.989,0-2.2-1.758-.769-2.2h.11Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.528,7.912c-.769-.33-.549-1.429.11-1.868a.82.82,0,0,1,1.429.44,1.634,1.634,0,0,1-1.429,1.429Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.154,12.088a1.751,1.751,0,0,1-1.319-.989A.844.844,0,0,1,15.6,10c.989,0,1.758,1.538.659,2.088Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,7.253c-.22,1.429-2.088.44-2.088-.659.22-1.429,1.868-.44,2.088.549h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.824,8.682A1.751,1.751,0,0,1,4.835,10a.844.844,0,0,1-1.1-.769c0-.989,1.538-1.758,2.088-.659h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.726,9.451c-.44,1.1-2.088.22-2.088-.769.22-1.538,1.978-.44,2.088.659h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.319,7.912c1.429.33.33,2.088-.659,2.088-1.429-.22-.44-2.088.549-2.088h.11Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.891,10.879c-.11.989-1.868,1.978-2.088.549,0-.989,1.758-2.2,2.088-.659h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.264,7.912c-1.1-.44-.33-1.978.659-1.978a.812.812,0,0,1,.769,1.1,1.751,1.751,0,0,1-1.319.989h-.11Z",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutrasCulturasRegadio);
export default __webpack_public_path__ + "static/media/outras_culturas_regadio.f1ed2583714b6b8e97a4f400819c9d29.svg";
export { ForwardRef as ReactComponent };